import React, {Component} from 'react';
import './QuestionItem.css';
import PropTypes from 'prop-types';
import QuestionAnswer from "./QuestionAnswer";

export default class QuestionItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            processingCheck: false
        };
    }

    render() {
        let classNames = ["QuestionItem"];

        let subText = "Deze vraag is nog niet beantwoord.";

        if (this.props.question.answer && this.props.question.answer.response) {
            subText = <QuestionAnswer value={this.props.question.answer.response}/>;
            classNames.push("QuestionItem--answered");
        }

        let subItems = [];

        for (let i = 0; i < this.props.question.sub_answers.length; i++) {
            let subAnswer = this.props.question.sub_answers[i];

            if (subAnswer && subAnswer.response) {
                subItems.push(<div className={"QuestionItem__text-subitem"} key={`sa-${subAnswer.step_id}`}>
                    <span>{subAnswer.question_number}. {subAnswer.question_title}</span>
                    <QuestionAnswer value={subAnswer.response}/>
                </div>);
            }
        }

        return (
            <div className={classNames.join(' ')}>
                <div className={"QuestionItem__text"} onClick={this.props.onQuestionClick}>
                    <strong className={"QuestionItem__text-title"}>{this.props.question.question_number}. {this.props.question.question_title}</strong>
                    {subText && <div className={"QuestionItem__text-sub"}>{subText}</div>}
                    {subItems}
                </div>
            </div>
        );
    }
}

QuestionItem.propTypes = {
    question: PropTypes.object.isRequired,
    onQuestionClick: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/Portal/Wishlist/QuestionItem.js